import React from 'react';
import AddFund from './AddFund';

export default function AddFundContainer() {
  return <AddFund />;
}
